<template>
  <div class="bui-tbl-bottombar">
    <TblPagination
      v-if="totalPages > 1"
      :current-page="currentPageNumber"
      :total-pages="totalPages"
      @change="setCurrentPageNumber"
    />
  </div>
</template>

<script lang="ts" setup>
import { computed, inject } from 'vue';
import TblPagination from '../../molecules/TblPagination/TblPagination.vue';

const itemsListHelpers = inject<any>('itemsListHelpers');

const totalPages = computed(() => itemsListHelpers?.totalPages?.value ?? 1);
const currentPageNumber = computed(() => itemsListHelpers?.currentPageNumber?.value ?? 1);

function setCurrentPageNumber(p: number) {
  itemsListHelpers?.setCurrentPageNumber?.(p);
}
</script>

<style lang="scss" scoped>
.bui-tbl-bottombar {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 24px;
  padding-top: 16px;
  flex-wrap: wrap;
  min-height: 0;
}

@media (max-width: 768px) {
  .bui-tbl-bottombar {
    justify-content: center;
    gap: 10px;
    padding-top: 8px;
  }
}
</style>
